import Navbar from "./components/Navbar";
import GameWindow from "./components/GameWindow";

function App() {
  return (
    <div className="App">
      <Navbar />
      <GameWindow />
    </div>
  );
}

export default App;
